module.exports = __webpack_public_path__ + "img/vega-psykologi-logo.9801fe47.png";